import { createContext } from "react";

interface IBlockedTenant {
  tenantId: string;
  blocked: boolean;
  service: string;
}

export interface ProvisionalStatus {
  isProvisional: boolean;
  operation?: "deleting" | "updating" | "inserting";
  currentSet?: "A" | "B" | "C";
  deleted?: number;
  updated?: number;
  inserted?: number;
}

export const ReconciliationServiceContext = createContext<{
  working: boolean;
  isBatchRunning: boolean;
  setIsBatchRunning: (running: boolean) => void;
  uploadId?: string;
  uploadMessage?: string;
  isConnected: boolean;
  lastError?: string;
  resetUploadId: () => void;
  processing: boolean;
  logicalDelete: boolean;
  blockedTenant: IBlockedTenant | null;
  provisionalStatus: ProvisionalStatus;
  setActiveSubsourceId: (subsourceId: string | undefined) => void;
}>({
  working: false,
  isBatchRunning: false,
  setIsBatchRunning: () => undefined,
  isConnected: false,
  uploadMessage: undefined,
  resetUploadId: () => undefined,
  processing: false,
  logicalDelete: false,
  blockedTenant: null,
  provisionalStatus: { isProvisional: false },
  setActiveSubsourceId: () => undefined,
});
